module.exports = __webpack_public_path__ + "images/file_icons_v2/rss-9d107b28af816809666be2ea949a60a0.svg";